import { observer } from "mobx-react";
import SelectDropdownMulti, { IOption } from "../../../../../components/inputs/select-dropdown-multi/select-dropdown-multi";
import { isSet } from "../../../../../models/model-types-methods";
import { AddLanguageWizardStore } from "../../../stores/add-language-wizard-store";
import AddLanguageWizardStepTitle from "../add-language-wizard-step-title";


interface IProps {
    wizardStore: AddLanguageWizardStore
}

const SelectLanguageStep: React.FC<IProps> = observer(({ wizardStore }) => {
    return (
        <div>
            <AddLanguageWizardStepTitle
                title={"First Step: Select Language"}
                subtitle={"Select language you want to add from the list below:"}
            />
            {isSet(wizardStore.localesOptions) && (
                <SelectDropdownMulti
                    options={wizardStore.localesOptions!}
                    value={wizardStore.selectedLocalesOptions}
                    onChange={selectedLocalesOptions => {
                        wizardStore.setSelectedLocalesOptions(selectedLocalesOptions as IOption[]);
                    }}
                />
            )}
        </div>
    );
});

export default SelectLanguageStep;